import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import { default as React, useContext, useState } from 'react';
import styled from 'styled-components';
import { v4 as uuidv4 } from 'uuid';
import { OPTION_GROUPS_MODALS } from '../../constants';
import {
  DispatchContext,
  StateContext,
} from '../../contexts/use-menu-editor-context';
import Done from '../shared/Done';
import ExitButton from '../shared/Exit';
import OptionGroupCreateModal from './option-group-create-modal';
import OptionGroupListModal from './option-group-list-modal';

const Header = styled.h1`
  font-family: Geomanist;
  font-style: normal;
  font-weight: normal;
  font-size: 25px;
  line-height: 25px;
  text-align: center;
  letter-spacing: -0.4px;
`;

const Border = styled.div`
  height: 1px;
  left: 0px;
  right: 0px;
  border-bottom: 1px solid #eeeeee;
`;

function OptionGroupModals({
  close,
  parent,
  product,
  groups,
  setGroups,
  fetchAllOptionGroups,
  allGroups,
  isLoading,
  setIsLoading,
  ...other
}) {
  const [selectedOptionGroup, setSelectedOptionGroup] = useState({});

  const showDoneButton = Boolean(
    Object.entries(selectedOptionGroup).filter(e => e[1]).length
  );

  const context = useContext(StateContext);

  const {
    state: { menus, ogModalMode, groupToEdit, isManageMode },
    client,
  } = context;

  const dispatch = useContext(DispatchContext);

  const setSelectedDialog = mode => {
    dispatch({
      type: 'SET_OG_MODAL_MODE',
      payload: {
        ogModalMode: mode,
      },
    });
  };

  const setGroupToEdit = group => {
    dispatch({
      type: 'SET_GROUP_TO_EDIT',
      payload: {
        groupToEdit: group,
      },
    });
  };

  const handleSetOptionGroup = () => {
    setIsLoading(true);
    if (!product) {
      // create product flow
      const productId = `tbc-${uuidv4()}`;

      const optionGroupIds = Object.entries(selectedOptionGroup)
        .filter(e => e[1])
        .map(i => i[0]);
      const groupsToUpdate = allGroups.filter(g =>
        optionGroupIds.includes(g.id)
      );
      const groupsToKeep = allGroups.filter(
        g => !optionGroupIds.includes(g.id)
      );
      const newGroups = groupsToUpdate.map(group => {
        return {
          ...group,
          productIds: [...group.productIds, productId],
        };
      });
      setGroups([...groupsToKeep, ...newGroups]);
      close();
    } else {
      // edit product flow
      const productId = product.id;
      const optionGroupIds = Object.entries(selectedOptionGroup)
        .filter(e => e[1])
        .map(i => i[0]);
      const groupsToUpdate = groups.filter(g => optionGroupIds.includes(g.id));
      const newGroups = groupsToUpdate.map(group => {
        return {
          ...group,
          productIds: [...group.productIds, productId],
        };
      });

      const updateGroupsCalls = newGroups.map(async group => {
        try {
          await client.post('/update-option-group', group);
        } catch (err) {
          console.error('Failed to update option group', group, err);
        }
      });

      Promise.all(updateGroupsCalls).then(() => {
        fetchAllOptionGroups().then(() => {
          setIsLoading(false);
          close();
        });
      });
    }
  };

  const renderDialog = () => {
    if ('') {
      return (
        <React.Fragment>
          <DialogTitle id="responsive-dialog-title">
            <Header>Customisation Options</Header>
          </DialogTitle>
          <Border />
        </React.Fragment>
      );
    }

    switch (ogModalMode) {
      case OPTION_GROUPS_MODALS.LIST:
        return (
          <OptionGroupListModal
            setSelectedDialog={setSelectedDialog}
            setGroupToEdit={setGroupToEdit}
            groups={groups || []}
            menus={menus}
            selectedOptionGroup={selectedOptionGroup}
            setSelectedOptionGroup={setSelectedOptionGroup}
            isManageMode={isManageMode}
            product={product}
          />
        );
      case OPTION_GROUPS_MODALS.CREATE:
        return (
          <OptionGroupCreateModal
            close={close}
            setSelectedDialog={setSelectedDialog}
            groups={groups}
            allGroups={allGroups}
            setGroups={setGroups}
            parent={parent}
            menus={menus}
            isManageMode={isManageMode}
            product={product}
          />
        );
      case OPTION_GROUPS_MODALS.EDIT:
        return (
          <OptionGroupCreateModal
            close={close}
            setSelectedDialog={setSelectedDialog}
            group={groupToEdit}
            groups={groups}
            allGroups={allGroups}
            setGroups={setGroups}
            menus={menus}
            parent={parent}
            isManageMode={isManageMode}
            product={product}
          />
        );
      default:
    }
  };

  return (
    <Dialog
      open={true}
      keepMounted
      onClose={close}
      fullWidth={true}
      maxWidth="md"
      {...other}
    >
      {showDoneButton ? (
        <Done isLoading={isLoading} onClick={handleSetOptionGroup} />
      ) : (
        <ExitButton onClick={close} />
      )}

      {renderDialog()}
    </Dialog>
  );
}

const styles = {
  paper: {
    borderRadius: '11px',
    width: '895px',
  },
};
export default withStyles(styles)(OptionGroupModals);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/GlobalOptions/option-group-modals.jsx